import SafeHTMLComponent from '@/services/ecommerce/utils/SafeHTMLComponent';
import { ProductSwitcher } from './ProductSwitcher';
import styles from './product.module.scss';
export const ProductDescription = ({ data }: any) => {
	const { p_description, p_type } = data;
	if (!p_description?.html) return null;
	return (
		<div
			className={'bg-white rounded-10  border-1-grey300 rounded-10'}
			style={{
				overflow: 'hidden'
			}}>
			<div className='d-flex justify-space-between  border-b1-grey300 p-20'>
				<div className='text-18 text-grey900 fw-600'>
					<span className='ml-10'>{p_type === 'medicine' ? 'Description' : 'Product Description'}</span>
				</div>
				<ProductSwitcher />
			</div>

			<div className='text-14 text-grey900 fw-400 line-height-24 mb-10'>
				<div className={styles.p_description}>
					<ParseHtml data={p_description?.html} />
				</div>
			</div>
		</div>
	);
};

const ParseHtml = ({ data }: any) => {
	return (
		<SafeHTMLComponent
			htmlContent={data}
			className='text-14 text-grey700 fw-400 p-20'
			style={{ lineHeight: '24px' }}
		/>
	);
};
